export const sidebarWidth = 20

export const primaryColor = '#1db9aa'
export const secondaryColor = '#677897'
export const secondaryLightColor = '#ddd'
export const secondaryLighterColor = '#f4f4f4'
export const hoverColor = primaryColor
export const alternativeHoverColor = primaryColor
export const whiteColor = '#fff'
export const blackColor = '#000'

export default {
  colors: {
    primary: primaryColor,
    secondary: secondaryColor,
    secondaryLight: secondaryLightColor,
    secondaryLighter: secondaryLighterColor,
    hover: hoverColor,
    alternativeHover: alternativeHoverColor,
    white: whiteColor,
    black: blackColor,
    icons: {
      iconAll: hoverColor,
      iconGood: '#1cc100',
      iconMaybe: '#f5b83b',
      iconBad: 'red',
    },
  },
  sidebar: {
    backgroundColor: '#F7F7F7',
    width: `${sidebarWidth}%`,
    height: '100vh',
  },
  drawer: {
    lineWidth: 3,
    color: primaryColor,
  },
}



// WEBPACK FOOTER //
// ./src/theme/globalTheme.js